import type { UUID } from "@/core/types";

export const addendumKeys = {
  byNote: (noteId: UUID) => ["note", noteId, "addendums"] as const,
} as const;
